module.exports = __webpack_public_path__ + "static/img/goods-800.a49b474.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s28/pop/goods-800.png
// module id = d04A
// module chunks = 2